import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';

import s from './WhatsAppFloatingButton.css';

const WHATSAPP_ICON_PATH = '/images/favicon/whatsapp-icon.png';

const sanitizeWhatsAppNumber = (phoneNumber) => {
  if (!phoneNumber) return null;

  const digitsOnly = phoneNumber.toString().replace(/\D/g, '');

  return digitsOnly || null;
};

const WhatsAppFloatingButton = ({ phoneNumber }) => {
  const normalizedPhoneNumber = sanitizeWhatsAppNumber(phoneNumber);

  if (!normalizedPhoneNumber) {
    return null;
  }

  return (
    <a
      href={`https://wa.me/${normalizedPhoneNumber}`}
      className={s.floatingButton}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Open WhatsApp chat"
      title="Chat via WhatsApp"
    >
      <img src={WHATSAPP_ICON_PATH} className={s.icon} alt="" aria-hidden="true" />
    </a>
  );
};

WhatsAppFloatingButton.propTypes = {
  phoneNumber: PropTypes.string,
};

const mapState = (state) => ({
  phoneNumber: state?.siteSettings?.data?.contactPhoneNumber,
});

export default connect(mapState)(withStyles(s)(WhatsAppFloatingButton));
